export default __webpack_public_path__ + "chevron-ring.b7ff8f8940e9706e.svg";